import { render, staticRenderFns } from "./imgShow.vue?vue&type=template&id=7b4ebb65&scoped=true"
import script from "./imgShow.vue?vue&type=script&lang=js"
export * from "./imgShow.vue?vue&type=script&lang=js"
import style0 from "./imgShow.vue?vue&type=style&index=0&id=7b4ebb65&prod&scoped=true&lang=css"
import style1 from "./imgShow.vue?vue&type=style&index=1&id=7b4ebb65&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4ebb65",
  null
  
)

export default component.exports